import { reset } from '@/state/store';
import { localStorage } from '@bimdata/client';
import api from '@/api/api';
import { stopFetchCycle } from '@/loaders/events';

api.addEventListener('sessionClosed', () => {
  reset();
});

export default async () => {
  stopFetchCycle();

  api.closeSession();
  localStorage.clear();
};
